import { ArrowRight, Sparkles, Star, Zap } from 'lucide-react';
import { Button } from '../ui/button';
import { PURCHASE_URL, PRODUCT_IMAGES } from '../../data/mock';
import { trackPurchaseClick } from '../../utils/pixel';

// Eye image used in ProblemSection


const handlePurchase = () => {
  trackPurchaseClick();
  window.open(PURCHASE_URL, '_blank', 'noopener,noreferrer');
};

export const HeroSection = () => {
  return (
    <>
      {/* Hero Section - Full immersive */}
      <section className="relative min-h-screen flex items-center overflow-hidden" style={{ background: 'linear-gradient(160deg, #FDF2F8 0%, #FCE7F3 30%, #FBCFE8 60%, #FCE7F3 100%)' }}>
        {/* Soft gradient blobs only */}
        <div className="absolute top-[-100px] right-[-100px] w-[500px] h-[500px] rounded-full blob opacity-25" style={{ background: 'radial-gradient(circle, #FBCFE8 0%, transparent 70%)' }} />
        <div className="absolute bottom-[-50px] left-[-100px] w-[600px] h-[600px] rounded-full blob-delay opacity-20" style={{ background: 'radial-gradient(circle, #F9A8D4 0%, transparent 70%)' }} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full opacity-10" style={{ background: 'radial-gradient(circle, #F472B6 0%, transparent 70%)' }} />

        <div className="relative z-10 max-w-7xl mx-auto px-6 pt-16 pb-20 md:pt-20 md:pb-24">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Text Content */}
            <div className="space-y-8">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full shimmer-border" style={{ backgroundColor: 'rgba(252, 231, 243, 0.8)', border: '1px solid rgba(249, 168, 212, 0.3)' }}>
                <Sparkles size={14} style={{ color: '#DB2777' }} />
                <span className="font-body text-xs font-semibold tracking-wider uppercase" style={{ color: '#9D174D' }}>Manual Digital Profesional</span>
              </div>

              <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight" style={{ color: '#1F1235' }}>
                Deja de practicar con inseguridad.{' '}
                <span className="gradient-text italic">Empieza a diseñar con certeza profesional.</span>
              </h1>

              <p className="font-body text-lg leading-relaxed max-w-lg" style={{ color: '#4A3B5C' }}>
                Descubre la base estructurada que te permite entender el diseño completo y confirmar cada decisión mientras trabajas.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 items-start">
                <Button onClick={handlePurchase} size="lg" className="cta-pulse rounded-full text-white font-body font-bold text-base px-10 py-6 h-auto" style={{ backgroundColor: '#DB2777' }}>
                  Acceder al Manual Ahora
                  <ArrowRight size={18} className="ml-1" />
                </Button>
              </div>

              <div className="flex flex-wrap gap-6 pt-2">
                {[
                  { icon: <Zap size={14} />, text: 'Acceso inmediato' },
                  { icon: <Star size={14} />, text: 'Manual digital' },
                  { icon: <Sparkles size={14} />, text: 'Bonos incluidos' }
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(252,231,243,0.8)', color: '#DB2777' }}>{item.icon}</div>
                    <span className="font-body text-sm" style={{ color: '#7E6E91' }}>{item.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Product Image - Hero visual */}
            <div className="flex justify-center lg:justify-end">
              <div className="perspective-container">
                <div className="product-3d relative">
                  <img
                    src={PRODUCT_IMAGES.main}
                    alt="Manual Cejas Radiantes"
                    className="w-full max-w-lg rounded-3xl"
                    style={{ objectFit: 'cover' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Smooth wave transition */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" className="w-full h-16">
            <path d="M0 100V60C180 30 360 70 540 65C720 60 900 20 1080 30C1260 40 1380 70 1440 60V100H0Z" fill="rgba(253,242,248,0.5)"/>
            <path d="M0 100V75C240 50 480 85 720 80C960 75 1200 45 1440 55V100H0Z" fill="rgba(252,231,243,0.8)"/>
          </svg>
        </div>
      </section>

      {/* Scrolling marquee band */}
      <div className="overflow-hidden py-4" style={{ background: 'linear-gradient(90deg, rgba(253,242,248,0.9), rgba(252,231,243,0.9), rgba(253,242,248,0.9))' }}>
        <div className="flex animate-marquee whitespace-nowrap">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="flex items-center gap-8 mx-8">
              <Star size={12} style={{ color: '#F9A8D4' }} />
              <span className="font-display text-xs tracking-widest uppercase" style={{ color: '#D4A0B9' }}>Diseño con Certeza</span>
              <Star size={12} style={{ color: '#F9A8D4' }} />
              <span className="font-display text-xs tracking-widest uppercase" style={{ color: '#D4A0B9' }}>Cejas Radiantes</span>
              <Star size={12} style={{ color: '#F9A8D4' }} />
              <span className="font-display text-xs tracking-widest uppercase" style={{ color: '#D4A0B9' }}>Manual Profesional</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
